/**
 * Administration copy: notifications, the mobile app's distribution, the Zoho
 * Desk connection, server health and the dev-only component gallery. Carried
 * verbatim from the previous app (apps/web/src/i18n/ar.ts and batch.ts), minus
 * the removed server-side APK builder; keys marked "new" are not from it.
 */
export const adminAr = {
  notify: {
    // New copy (UX audit #11): needs native review.
    emptyNone: 'لم تُرسل أي إشعارات بعد.',
    nav: 'الإشعارات',
    title: 'الإشعارات',
    description:
      'ابعت إشعار لمندوب أو مجموعة أو فريق أو للكل. بيوصل كمان لقائمة الإشعارات في التطبيق، فمفيش حاجة بتضيع لو الإشعار موصلش. كل إرسال بيتسجل في سجل المراجعة.',
    compose: 'إشعار جديد',
    audience: 'إرسال إلى',
    audiences: { USERS: 'مناديب مختارين', TEAM: 'فريق', EVERYONE: 'الكل' },
    agents: 'المناديب',
    team: 'فريق',
    titleAr: 'العنوان (عربي)',
    titleEn: 'العنوان (إنجليزي، اختياري)',
    bodyAr: 'الرسالة (عربي)',
    bodyEn: 'الرسالة (إنجليزي، اختياري)',
    deepLink: 'بيفتح في التطبيق',
    deepLinkNone: 'قائمة الإشعارات',
    targets: {
      home: 'الرئيسية',
      tasks: 'مهامي',
      pending: 'المزامنة',
      performance: 'زياراتي',
      settings: 'الإعدادات',
      notifications: 'قائمة الإشعارات',
      assignment: 'مهمة معينة',
    },
    preview: 'معاينة',
    previewTitle: 'راجع قبل الإرسال',
    previewCounts: '{{recipients}} مستلم · {{reachable}} عندهم موبايل متسجل ({{devices}} موبايل) · {{muted}} كاتمين الإعلانات',
    previewMuted: 'اللي كاتمين الإعلانات بيوصلهم في قائمة التطبيق بس.',
    send: 'إرسال',
    sent: 'الإشعار اتبعت',
    history: 'السجل',
    sentBy: 'المرسل',
    recipients: 'المستلمين',
    delivery: 'التوصيل',
    deliveries: 'التوصيل لكل موبايل',
    kind: { ASSIGNMENT: 'مهمة', ANNOUNCEMENT: 'إعلان', TEST: 'تجربة' },
    statuses: {
      QUEUED: 'في الطابور',
      SENT: 'اتبعت',
      DELIVERED: 'وصل للمنصة',
      FAILED: 'فشل',
      NO_DEVICE: 'مفيش موبايل متسجل',
      MUTED: 'مكتوم',
      NOT_SENT: 'متبعتش',
    },
    read: 'اتقرا',
    platform: 'المنصة',
    reason: 'إيه اللي حصل',
    audienceUsers: '{{count}} شخص',
    audienceUsers_one: 'شخص واحد',
    audienceUsers_two: 'شخصان',
    audienceUsers_few: '{{count}} أشخاص',
    audienceTeam: 'فريق {{name}}',
    audienceTest: 'تجربة: {{name}}',
    device: 'الموبايل',
    testSelf: 'ابعت إشعار تجريبي لنفسي',
    testSend: 'ابعت التجربة',
    testAgain: 'ابعت تاني',
    testHint:
      'بيبعت إشعار تجريبي دلوقتي لكل موبايل إنت مسجّل دخول عليه في تطبيق الموبايل. اقفل التطبيق على الموبايل الأول: لو الإشعار ظهر، يبقى التوصيل شغال.',
    testWaiting: 'مستنيين تأكيد التسليم من Google/Apple…',
    testNoReceipt: 'لسه مفيش تأكيد. Expo ممكن ياخد كام دقيقة؛ افتح التجربة دي من السجل بعدين عشان تشوف النتيجة النهائية.',
    testOutcomes: { DELIVERED: 'وصل', SENT: 'اتبعت، مستني', FAILED: 'فشل', NO_TOKEN: 'مفيش رقم إشعارات' },
  },
  env: {
    development: 'تطوير',
    staging: 'تجريبي',
    production: 'إنتاج',
  },
  status: {
    api: 'الخادم',
    apiOk: 'متصل',
    apiDegraded: 'يعمل جزئياً',
    apiDown: 'غير متاح',
    database: 'قاعدة البيانات',
    queue: 'عامل المزامنة',
    up: 'يعمل',
    down: 'متوقف',
    disabled: 'معطّل',
    zoho: 'Zoho',
    zohoConnected: 'متصل',
    zohoNotConfigured: 'غير مُعد',
    zohoTestFailed: 'فشل آخر اختبار',
    zohoUntested: 'لم يُختبر',
  },
  zoho: {
    title: 'الربط مع Zoho Desk',
    description: 'اتصال OAuth وإعدادات التذاكر التي يستخدمها عامل المزامنة في كل طلب إلى Zoho Desk.',
    configuration: 'الإعداد',
    connection: 'الاتصال',
    connectionSubtitle: 'آخر اختبار اتصال',
    dataCenter: 'مركز البيانات',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    storedSecret: 'محفوظ مشفراً — اتركه فارغاً للإبقاء',
    orgId: 'رقم المؤسسة (Org ID)',
    departmentId: 'رقم القسم (Department ID)',
    layoutId: 'رقم التخطيط (اختياري)',
    ticketStatus: 'حالة التذكرة الجديدة',
    ticketChannel: 'قناة التذكرة',
    contactStrategy: 'جهة الاتصال للتذكرة',
    contactFixed: 'جهة اتصال ثابتة لكل الزيارات',
    contactFromForm: 'بحث أو إنشاء من حقول النموذج',
    fixedContactId: 'رقم جهة الاتصال الثابتة',
    contactNameField: 'حقل اسم جهة الاتصال',
    contactPhoneField: 'حقل موبايل جهة الاتصال',
    redirectUri: 'رابط إعادة التوجيه للتسجيل في Zoho API Console',
    connect: 'الاتصال بـ Zoho',
    reconnect: 'إعادة الاتصال',
    disconnect: 'فصل الاتصال',
    // New copy (UX audit #2): needs native review.
    disconnectTitle: 'فصل الاتصال بـ Zoho Desk؟',
    disconnectConsequence: 'ستتوقف مزامنة الزيارات مع Zoho Desk. تبقى الزيارات محفوظة وتنتظر حتى تعيد الاتصال.',
    testTicketTitle: 'إنشاء تذكرة تجريبية؟',
    connected: 'متصل عبر OAuth',
    notConnected: 'غير متصل — تُحفظ الزيارات ولا تتم مزامنتها',
    test: 'اختبار الاتصال',
    testOk: 'نجح آخر اختبار',
    testFailed: 'فشل آخر اختبار',
    notTested: 'لم يُختبر',
    testTicket: 'إنشاء تذكرة تجريبية',
    testTicketHint: 'ينشئ تذكرة مُعلّمة TEST في Zoho Desk باستخدام النموذج النشط والربط الحالي.',
    testTicketCreated: 'تم إنشاء التذكرة التجريبية {{number}}',
    sentPayload: 'البيانات المرسلة',
    oauthSuccess: 'تم الاتصال بـ Zoho Desk.',
    oauthError: 'فشل الاتصال بـ Zoho Desk: {{reason}}',
    saveFirst: 'احفظ Client ID وClient secret قبل الاتصال.',
    lastTest: 'آخر اختبار',
    lastTestMessage: 'نتيجة آخر اختبار',
    lastTestReason: 'سبب الفشل', // new — needs native review
    testFailedReason: 'فشل اختبار الاتصال: {{reason}}', // new — needs native review
    apiBaseUrl: 'عنوان الـ API',
    /** New: the OAuth callback's reason codes in words (the previous app showed the code). */
    oauthReasons: {
      STATE_INVALID: 'رابط الاتصال غير صالح أو اتستخدم قبل كده. ابدأ الاتصال من جديد.',
      STATE_EXPIRED: 'رابط الاتصال انتهت صلاحيته. ابدأ الاتصال من جديد.',
      ACCESS_DENIED: 'الإذن اترفض في Zoho.',
      MISSING_CODE: 'Zoho مارجّعش كود التفويض.',
      NOT_CONFIGURED: 'احفظ Client ID وClient secret قبل الاتصال.',
      DATA_CENTER_MISMATCH: 'مركز البيانات المختار مختلف عن حساب Zoho.',
      NO_REFRESH_TOKEN: 'Zoho مارجّعش refresh token. شيل صلاحية التطبيق من حساب Zoho وبعدين اتصل تاني.',
      EXCHANGE_FAILED: 'تبادل الكود مع Zoho فشل. راجع Client ID وClient secret.',
    },
    /** New: the ticket layout's fields, as the form builder maps to them. */
    ticketFields: 'حقول التذكرة',
    ticketFieldsHint: 'حقول تخطيط تذكرة Zoho Desk اللي ممكن حقول النموذج تتربط بيها.',
    loadTicketFields: 'تحميل من Zoho',
    ticketFieldsNeedConnection: 'احفظ الإعدادات واربط Zoho عشان تحمّل حقول التذكرة.',
    fieldApiName: 'اسم الـ API',
    fieldType: 'النوع',
    fieldMandatory: 'إجباري',
    fieldCustom: 'مخصص',
    allowedValues: 'القيم المسموحة',
    fetchedAt: 'وقت التحميل',
  },
  distribution: {
    title: 'توزيع تطبيق الموبايل',
    description: 'ارفع نسخة أندرويد هنا، وابعت للمندوبين الرابط أو كود الـ QR.',
    notConfigured: 'لم يتم رفع أي نسخة بعد.',
    status: {
      hosted: 'v{{version}} منشورة · رابط التثبيت شغال',
      external: 'مفيش نسخة مرفوعة هنا · المناديب بيثبتوا من الرابط الخارجي',
      revokedExternal: 'رابط v{{version}} اتلغى · المناديب بيثبتوا من الرابط الخارجي',
      revokedNoLink: 'رابط v{{version}} اتلغى · المناديب ملهمش رابط تثبيت',
      none: 'لسه مفيش نسخة ولا رابط تثبيت',
    },
    published: 'النسخة المنشورة',
    upload: 'رفع نسخة جديدة',
    settings: 'إعدادات التوزيع',
    builds: 'النسخ المحفوظة على الخادم',
    version: 'الإصدار',
    size: 'الحجم',
    uploadedAt: 'تاريخ الرفع',
    uploadedBy: 'رفعها',
    releaseNotes: 'ملاحظات الإصدار',
    apkFile: 'ملف APK',
    chooseApk: 'اختر ملف الـ APK',
    releaseNotesPlaceholder: 'مثال: إصلاح أخطاء وتحسين الأداء',
    apkFileHint: 'ملف ‎.apk‎ فقط، حتى {{max}}. يتم التحقق من الملف قبل نشره.',
    uploadAndPublish: 'رفع ونشر',
    uploading: 'جارٍ الرفع…',
    keepsLastBuilds: 'الخادم يحتفظ بآخر {{count}} نسخة ويحذف الأقدم.',
    keepsLastBuilds_one: 'الخادم يحتفظ بآخر نسخة فقط ويحذف الأقدم.',
    keepsLastBuilds_two: 'الخادم يحتفظ بآخر نسختين ويحذف الأقدم.',
    keepsLastBuilds_few: 'الخادم يحتفظ بآخر {{count}} نسخ ويحذف الأقدم.',
    downloadLink: 'رابط التحميل',
    openLandingPage: 'فتح صفحة التثبيت',
    copyLink: 'نسخ الرابط',
    scanToInstall: 'امسح الكود بموبايل المندوب للتثبيت',
    linkRevoked: 'الرابط العام ملغي. غيّره لمشاركة هذه النسخة من جديد.',
    rotateLink: 'تغيير الرابط',
    revokeLink: 'إلغاء الرابط',
    // New copy (UX audit #2): needs native review.
    revokeTitle: 'إلغاء رابط التثبيت؟',
    revokeConsequence: 'سيتوقف الرابط الحالي ورمز QR عن العمل فورًا، ولن يستطيع المندوبون التثبيت منهما حتى تُجدّد الرابط.',
    rotateTitle: 'تجديد رابط التثبيت؟',
    rotateConsequence: 'سيحلّ رابط ورمز QR جديدان محل الحاليين، ويتوقف الرابط القديم عن العمل. أرسل الرابط الجديد للمندوبين.',
    publishTitle: 'نشر الإصدار v{{version}}؟',
    publishConsequence: 'سيقدّم رابط التثبيت ورمز QR هذا الإصدار من الآن، بدلاً من الإصدار المنشور حاليًا.',
    deleteBuildTitle: 'حذف الإصدار v{{version}}؟',
    deleteBuildConsequence:
      'سيُحذف ملف الإصدار من الخادم. وإن كان هو المنشور، فلن يكون للمندوبين رابط تثبيت مستضاف حتى تنشر إصدارًا آخر. لا يمكن التراجع عن ذلك.',
    publishThis: 'نشر هذه النسخة',
    state: 'الحالة',
    statePublished: 'منشورة',
    stateAvailable: 'متاحة',
    stateRevoked: 'الرابط ملغي',
    permissionRequired: 'تحتاج صلاحية «إدارة توزيع التطبيق» لتعديل هذا.',
    bandwidthWarning:
      'كل عملية تثبيت تستهلك حوالي {{size}} من باندويدث الخادم. ده مناسب لفريق صغير؛ لما عدد المندوبين يكبر، استضف الـ APK على درايف سحابي أو Play واستخدم الرابط الخارجي بالأسفل.',
    minimumVersion: 'أقل إصدار مدعوم',
    minimumVersionHint: 'أقل من كده، التطبيق يرفض إرسال الزيارات ويطلب من المندوب التحديث. اتركه فارغاً بدون حد أدنى.',
    externalUrl: 'رابط تثبيت خارجي (اختياري)',
    externalUrlHint: 'يُستخدم بدل الـ APK المستضاف هنا لو مفيش نسخة منشورة — مثلاً Play أو درايف سحابي.',
    externalIosUrl: 'رابط الآيفون (TestFlight)',
    externalIosUrlHint:
      'رابط تثبيت نسخة الآيفون عبر TestFlight؛ يظهر على صفحة التثبيت للمناديب أصحاب الآيفون. اتركه فارغاً لو مفيش نسخة iOS.',
    versionsInUse: 'إصدارات التطبيق المستخدمة',
    versionsInUseHint: 'مأخوذة من إصدار التطبيق المُرسل مع كل زيارة خلال آخر 90 يوماً.',
    noVersionsSeen: 'لا توجد زيارات في آخر 90 يوماً.',
    unknownVersion: 'غير مُبلَّغ',
    agents: 'المندوبون',
    visits: 'الزيارات',
    lastSeen: 'آخر ظهور',
    serverEndpoints: 'عنوان اتصال السيرفر (Server IP)',
    publicIp: 'الـ IP العام (WAN)',
    localIp: 'الـ IP المحلي (LAN)',
    useIp: 'استخدم {{label}} {{ip}}',
    publicIpNeedsHttps: 'العنوان العام محتاج https (دومين أو tunnel)؛ نسخة التطبيق مش هتقبل http عادي ليه.',
    targetApiUrl: 'رابط واجهة السيرفر (API URL)',
    targetApiUrlHint: 'هو الرابط الذي سيتصل به تطبيق الموبايل على هواتف المناديب. تأكد من إمكانية الوصول إليه.',
    testConnection: 'فحص إمكانية الاتصال',
    endpointReachable: 'الرابط متاح ويعمل بنجاح (استجابة: {{ms}} مللي ثانية)',
    endpointUnreachable: 'تعذر الاتصال بالرابط: {{reason}}',
    shareWhatsApp: 'مشاركة عبر واتساب',
    whatsAppShareMessage: 'تحميل تطبيق الدعم الميداني Field Support (الإصدار v{{version}}): {{url}}',
    /** New: the server health card and the technical detail of a failed check. */
    health: 'حالة الخادم',
    apiVersion: 'إصدار الخادم',
    technicalDetail: 'تفاصيل فنية',
    /** Why an address check failed (ENDPOINT_CHECK_REASONS), inside endpointUnreachable. */
    endpointReason: {
      INVALID_URL: 'الرابط مش صحيح', // new — needs native review
      UNSUPPORTED_PROTOCOL: 'الرابط لازم يبدأ بـ http:// أو https://', // new — needs native review
      CREDENTIALS_IN_URL: 'شيل اسم المستخدم وكلمة المرور من الرابط', // new — needs native review
      ADDRESS_NOT_ALLOWED: 'العنوان ده مش مسموح (محلي أو محجوز)', // new — needs native review
      DNS_FAILED: 'اسم السيرفر مش موجود (DNS)', // new — needs native review
      TIMEOUT: 'مفيش رد في الوقت المحدد', // new — needs native review
      CONNECTION_REFUSED: 'الاتصال اترفض: مفيش حاجة شغالة على البورت ده', // new — needs native review
      TLS_ERROR: 'الاتصال الآمن فشل (الشهادة منتهية أو موقّعة ذاتياً أو لاسم تاني)', // new — needs native review
      UNREACHABLE: 'الرابط مش قابل للوصول', // new — needs native review
      HTTP_REDIRECT: 'السيرفر رد بتحويل (HTTP {{statusCode}})؛ استخدم الرابط النهائي', // new — needs native review
      HTTP_ERROR: 'السيرفر رد بخطأ (HTTP {{statusCode}})', // new — needs native review
    },
  },
  gallery: {
    title: 'معرض المكونات',
    description: 'كل مكونات الواجهة بكل حالاتها بالعربية (من اليمين) والإنجليزية (من اليسار). في نسخ التطوير فقط.',
  },
};
